// Home画面関連の型定義

import { DeviceState } from './media-preview';


// ステータスの定義
export enum ShotStatus {
  NEW = 1,
  UPDATE = 2,
  PRODUCER_PENDING = 3,
  CLIENT_PENDING = 4,
  APPROVED = 5,
  APPROVED_WITH_DELIVERY_FILE = 6,
  PRODUCER_DONE_CLIENT_UNAPPROVED = 7
}

// プロジェクト進捗情報
export interface ProjectProgress {
  approvalRatio: number;
  currentRatio: number;
  approvalPercent: number;
  currentPercent: number;
  isComplete: boolean;
}

// ビューモードの型
// - schedule: プロジェクト内 Home のショット表
// - files: トークルームのファイル一覧（ストレージビュー）
// - table / gantt / activity: 横断タスクボードの表示切り替え
export type ViewMode =
  | 'in_progress'
  | 'completed'
  | 'all'
  | 'search'
  | 'schedule'
  | 'files'
  | 'table'
  | 'gantt'
  | 'activity';

// Redux State の型
export interface RootState {
  device: DeviceState;
}


// マイルストーン表示情報の判別共用体
export type MilestoneInfo =
  | { type: 'milestone'; event: string; days: number }
  | { type: 'end_date'; days: number }
  | { type: 'expired' };

// イベントハンドラーの型
export type HandleViewModeChange = (value: ViewMode) => void;
